module.exports = __webpack_public_path__ + "static/img/信息6.27d8d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息6.png
// module id = LE71
// module chunks = 1